//CONSIDER EDITING DASHBOARD DATA COLLECTION IF YOU HAVE TO TOUCH THIS FILE
export const GROUP_CREATE_URL =
  'https://data.mongodb-api.com/app/wizard-qpxfp/endpoint/wizard/submitStart';
export const GROUP_UPDATE_URL =
  'https://data.mongodb-api.com/app/wizard-qpxfp/endpoint/wizard/groupUpdate';